import React, { useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import GroupTextInput from './GroupTextInput';
import { useGetModuleData, useInsertModule, useUpdateCompanyModule, useUpdateModule } from '../../hooks/groups/Modules';
import { setObjectValue } from '../../helpers/general';
import GroupQuestionsList from './GroupQuestionsList';
import GroupCheckbox from './GroupCheckbox';
import GroupProductsList from './GroupProductsList';
import { useState } from 'react';
import LoadingSpinner from '../global/LoadingSpinner';
import SweetAlert from "sweetalert-react";
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye  } from '@fortawesome/free-solid-svg-icons';
import { useGetCurrentVendor, useGetVendorId } from '../../hooks/global/User';

function GroupsEditForm({ id, onClose, onNew, onUpdate, companyId = false }) {
    const { t } = useTranslation();

    const vendorId = useGetVendorId();
    const vendor = useGetCurrentVendor()

    const { data, isLoading } = useGetModuleData(id, companyId);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { mutate: update, isLoading: isUpdateLoading, isError: isUpdateError } = companyId ? useUpdateCompanyModule(companyId) : useUpdateModule(id);
    const { mutate: insert, data: insertedData, isError: isInsertError } = useInsertModule();

    const [formData, setFormData] = useState(null);
    const [newId, setNewId] = useState(id);
    const [isError, setIsError] = useState(false);
    const targetRef = useRef(null);

    useEffect(() => {
        if (data) {
            setFormData(Array.isArray(data) ? data[0] : data);
            if (targetRef.current && data) {
                targetRef.current.scrollIntoView({ behavior: 'smooth' }); 
            }
        }
    }, [data]);

    useEffect(() => {
    
        if (insertedData && !id) {
            setNewId(insertedData.id);
            formData.id = insertedData.id;
            onNew?.(insertedData.id)
        }
        setIsError(isInsertError);
    }, [insertedData, id, onNew, formData, isInsertError]);

    //Save data to DB
    const handleUpdate = (e) => {
        if(e.index === "display_element_details")
            e.data = !e.data
        setObjectValue(formData, e.index, e.data)
        formData.id ? update({ data: formData, message: t('toast.daCh') }) : insert({ data: formData, message: `${t('toast.crPr1')} ${t('toast.crPr2a')} ${t('admin.group.nm')}` });
    };

    const setSelectedProfileDrop = (companyID) => {
        let selected = data.find((company) => company.id === companyID);
        setFormData(selected);
    };

    if (isLoading || !formData) return <LoadingSpinner />

   // if(data)  return <pre>{JSON.stringify(data, null, 2)}</pre>
    //if (newId && data) return <pre>{JSON.stringify(data, null, 2)}</pre>
    //if(isInsertError) return <pre>{JSON.stringify(isInsertError, null, 2)}</pre>

    return (
        <div ref={targetRef} className="modulWrapOpen">
             <a href={companyId ? `/profiles/${formData.id}/review` : `/vendors/${vendorId}/review-group/${id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#414146", position: "absolute", top: "-20px", right: "0px" }}> <FontAwesomeIcon icon={faEye} /> </a>
            <div className="settingsWrap settingsWrapUpdate settingsWrapUpdateFirst">
                <div className="editMe-field">
                    <GroupTextInput index="descriptive_name" value={formData.descriptive_name} onSave={handleUpdate} open={(newId) ? false : true} disabled={companyId ? true : false} required={true} SAlert={(id) ? false : true} />
                </div>
            </div>
            {(!isInsertError && newId) && (<>
                <strong className="main">{t("admin.group.inv")}</strong>
                <div className="settingsWrap settingsWrapUpdate">
                    <div className="editMe-field">
                        <strong className="unbold">{t("admin.group.ti")}</strong>
                        <GroupTextInput index="texts.emailSubject" value={formData.texts.emailSubject} onSave={handleUpdate} />
                    </div>
                </div>
                <div className="settingsWrap settingsWrapUpdate">
                    <div className="editMe-field">
                        <strong className="unbold">{t("admin.group.sndr")}</strong>
                        <GroupTextInput index="texts.emailSender" value={formData.texts.emailSender} onSave={handleUpdate} />
                    </div>
                </div>
                <div className="settingsWrap settingsWrapUpdate">
                    <div className="editMe-field">
                        <strong className="unbold">{t("admin.group.con")}</strong>
                        <GroupTextInput index="texts.emailParagraph" value={formData.texts.emailParagraph} isText={true} onSave={handleUpdate} />
                    </div>
                </div>


                {/* from sms */}

                {(vendor?.services?.sms) && <>
                <strong className="main">{t("admin.group.invSms")}</strong>
                <div className="settingsWrap settingsWrapUpdate">
                    <div className="editMe-field">
                        <strong className="unbold">{t("admin.group.conSMS")}</strong>
                        <GroupTextInput index="texts.smsText" value={formData.texts.smsText} isText={true} onSave={handleUpdate} rule={/^.{1,155}$/s} maxLength={155} />
                    </div>
                </div></>
                }
                {/* end sms */}

                {(companyId && data.length > 1 ) &&
                <div className="settingsWrap settingsWrapMultipleUnit">
                    <div className="dropdownWrap">
                        <span className="label">{t("admin.group.unit")}</span>
                        <DropdownButton title={formData.name} id="selectCompanyDropdown">
                            {data.map((company, key) => {
                                return (
                                    <Dropdown.Item key={key} eventKey={company.id} onClick={() => setSelectedProfileDrop(company.id)}>
                                        {company.name}
                                    </Dropdown.Item>
                                );
                            })}
                        </DropdownButton>
                    </div>
                </div>}


                <strong className="main">{t("admin.group.form")}</strong>
                <div className="settingsWrap settingsWrapUpdate">
                    <div className="editMe-field">
                        <strong className="unbold">{t("admin.group.formAdd")}</strong>
                        <GroupTextInput index="texts.reviewTitle" value={formData.texts.reviewTitle} onSave={handleUpdate} />
                    </div>
                </div>

                <GroupQuestionsList id={id} index="question_ids" onSave={handleUpdate} list={companyId ? formData.question_ids : false} />

                {!companyId &&
                    <div className="productsWrap productsWrapUpdate">
                        <strong className="main">{t("admin.group.ele")}</strong>
                        <div className="editMe-field">
                            <GroupCheckbox index="display_element_details" value={!formData.display_element_details} label={t("admin.group.showE")} onChange={handleUpdate} />
                        </div>

                        <GroupProductsList id={id} />
                    </div>
                }
                <strong className="main">{t("admin.group.set")}</strong>
                <div className="settingsWrap">
                    <div className="editMe-customCheckbox">
                        <GroupCheckbox index="internal" value={formData.internal} label={t("admin.group.wPriv")} onChange={handleUpdate} />
                    </div>
                    <div className="editMe-customCheckbox">
                        <GroupCheckbox index="show_prize_game" value={formData.show_prize_game} label={t("admin.group.shPg")} onChange={handleUpdate} />
                    </div>
        
                    {(companyId) ?
                        (formData.code && <div className="settingsWrap settingsWrapGroupCode">
                            <div className="editMe-field">
                                <strong className="unbold">{t("admin.group.unCode")}</strong>
                                <em>{t("admin.group.elCodeText")}</em>
                                <input value={formData.code} disabled={true} />
                        </div></div>) :
                    <div className="editMe-field">
                        <strong className="unbold">{t("admin.group.mCode")}<span></span></strong>
                        <em>{t("admin.group.moduleText")}</em>
                        <input value={data.name} disabled={true} /> 
                    </div>
                        
                    }

                </div>
            </>)}
            <button type="button"
                className="btn btn-default btn-cancel"
                onClick={() => { onClose?.(formData.descriptive_name); onUpdate?.() }}
                title={t("admin.common.close")}>{t("admin.common.close")}</button>

            <SweetAlert
                show={isError}
                title={t("err.mo")}
                type="warning"
                text={t("err.LANCELOT_PRODUCT_GROUP_NAME_ALREADY_EXISTS_CONFLICT")}
                confirmButtonText="Ok"
                onConfirm={() => setIsError(false)}
            />
        </div>
    );
};

export default GroupsEditForm;